module.exports = __webpack_public_path__ + "static/img/PC-4.d4a9c5a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pcga/PC-4.png
// module id = ICe6
// module chunks = 0